import Temp from "@/courier/Temp";

export default class FlashExpressWarp extends Temp {
  static CODE = "FLEWP";

  constructor() {
    super(FlashExpressWarp.CODE);
  }

  listPostcodeSpecial = JSON.parse(localStorage.getItem("courier_postcode"));

  static TYPE_SAME_PROVINCE_NOT_BKK = "SAME_PROVINCE_NOT_BKK";
  static RULE_DIMENSION_WEIGHT = {
    SAME_PROVINCE_NOT_BKK: {
      max_weight: 19001,
      max_dimension: 220,
    },
  };
  getZone(item) {
    // replace ทุ่งปี๊ -> ทุ่งปี้ เพราะ address flash ใช้ปี้ เกิดมาเพื่อน้องแฟลชคนเดียว
    if (item.to.state == 'ทุ่งปี๊') {
      item.to.state = 'ทุ่งปี้';
    }
    let type, from, to;
    let cross_price = 0;
    let remote_area = 0;
    let travel_surcharge = 0;
    let island_surcharge = 0;

    remote_area = super.checkRemoteArea(Number(item.toPostcode));
    travel_surcharge = super.checkTravelSurcharge(Number(item.toPostcode));
    island_surcharge = super.checkTravelSurcharge(Number(item.toPostcode));
    if (travel_surcharge) {
      if (new Date().getTime() > new Date('2023-04-08 00:00:00').getTime()) {
        if (item.weight > 20000) {
          travel_surcharge = 200;
        } else if (item.weight > 7000) {
          travel_surcharge = 100;
        } else {
          travel_surcharge = 30;
        }
      } else {
        if (item.weight > 50000) {
          travel_surcharge = 150;
        } else if (item.weight > 30000) {
          travel_surcharge = 100;
        } else {
          travel_surcharge = 50;
        }
      }
    }

    let prefixFromPostCode = item.fromPostcode.toString().substring(0, 2);
    let prefixToPostCode = item.toPostcode.toString().substring(0, 2);

    // เฉพาะตอนโปร 9.9 FLE ถึง 27/12/2020
    if (Object.keys(item.courierRates).length < 2) {
      from = null;
      to = null;
    } else {
      from = super.checkZone(prefixFromPostCode);
      to = super.checkZone(prefixToPostCode);
    }

    if (["94", "95", "96"].indexOf(prefixToPostCode) > -1) {
      remote_area = this.listPostcodeSpecial[FlashExpressWarp.CODE].remotearea
        .special.cost;
    }

    if (
      ["94", "95", "96"].indexOf(prefixToPostCode) > -1 &&
      ["94", "95", "96"].indexOf(prefixFromPostCode) > -1
    ) {
      remote_area = 0;
    }
    const sameProvince = this.checkSameProvince(item);
    // ***remark***
    // BKK = Bangkok Metropolitan Region กรุงเทพและปริมณฑล
    // เฉพาะ to, from vvvvvvv
    // 1 = กทม. BKK | 2 = ภาคกลาง C | 3 = เหนือ N | 4 = ภาคอีสาน NE | 5 = ภาคใต้ S
    // ********************************************************************************
    // เฉพาะ type vvvvvvv
    // 1 = within same province only [ N, NE, S ]
    // 2 = [ N, NE, S ] to BKK
    // 3 = N to [ C, NE, S ]
    // 4 = NE to [ C, N, S ]
    // 5 = S to [ C, N, NE ]
    // 6 = BKK to BKK
    // 7 = [ BKK, C ] to Not in BKK
    // 8 = within same province only C
    // 9 = C to BKK
    if (
      ![to, from].includes(1) &&
      ![to, from].includes(2) &&
      to === from &&
      sameProvince &&
      this.checkRuleDimensionWeight(
        FlashExpressWarp.TYPE_SAME_PROVINCE_NOT_BKK,
        item
      )
    ) {
      type = 1;
    } else if (sameProvince && from === 2 && to === 2) {
      type = 8;
    } else if (![1, 2].includes(from) && to === 1) {
      type = 2;
    } else if (from === 3 && [2, 4, 5].includes(to)) {
      type = 3;
    } else if (from === 4 && [2, 3, 5].includes(to)) {
      type = 4;
    } else if (from === 5 && [2, 3, 4].includes(to)) {
      type = 5;
    } else if (from === 1 && to === 1) {
      type = 6;
    } else if ([1, 2].includes(from) && to !== 1) {
      type = 7;
    } else if (from === 2 && to === 1) {
      type = 9;
    } else {
      type = from;
    }
    return {
      rate_type: type,
      rate_remote_area: remote_area,
      travel_surcharge: travel_surcharge,
      island_surcharge: island_surcharge,
      cross_price: cross_price,
    };
  }
  checkRuleDimensionWeight(type, item) {
    const rule = FlashExpressWarp.RULE_DIMENSION_WEIGHT[type]
      ? FlashExpressWarp.RULE_DIMENSION_WEIGHT[type]
      : false;
    if (!rule) return rule;
    return (
      +item.weight < rule.max_weight && +item.culculateSize < rule.max_dimension
    );
  }
  checkSameProvince(item) {
    return (
      (!item.source && item.province.sameData == item.province.to) ||
      (item.source && item.province.from == item.province.to)
    );
  }
  checkWeight(courierRates, item, validate) {
    item.index = courierRates.findIndex((rate) => {
      return item.weight >= rate.min && item.weight <= rate.max;
    });

    return super.checkRules(item, validate);
  }

  checkDimension(dimensionCourier, item, validate) {
    return super.checkCourierDimension(dimensionCourier, item, validate);
  }

  calculateExtraTravel(selectedTier) {
    let travel_surcharge = 0;
    if (new Date().getTime() > new Date('2023-04-08 00:00:00').getTime()) {
      if (selectedTier.max > 20000) {
        travel_surcharge = 200;
      } else if (selectedTier.max > 7000) {
        travel_surcharge = 100;
      } else {
        travel_surcharge = 30;
      }
    } else {
      if (selectedTier.max > 50000) {
        travel_surcharge = 150;
      } else if (selectedTier.max > 30000) {
        travel_surcharge = 100;
      } else {
        travel_surcharge = 50;
      }
    }
    return travel_surcharge;
  }
  async checkRemoteAreaByCorrectorDest(addressRemote, option) {
    return new Promise((resolve) => {
      super.getArea([addressRemote], ["FLEWP"], option).then((res) => {
        let weight = option.weight;
        if (weight < ((option.price && option.price.selectedTier) ? option.price.selectedTier.max : 0)) {
          weight = option.price.selectedTier.max
        }
        let returnRate = {
          isRemote: res.data.FLEWP.is_remote?50:0,
          isTravelArea: 0,
          isIsland: res.data.FLEWP.is_island?30:0
        };
        
        if (res.data.FLEWP.is_tourist) {
          if (weight > 20000) {
            returnRate.isTravelArea = 200;
          } else if (weight > 7000) {
            returnRate.isTravelArea = 100;
          } else {
            returnRate.isTravelArea = 30;
          }
        }
        resolve(returnRate);
      });
    });
  }
}
